import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "roaming-counters__window-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "roaming-counters__window-list"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "roaming-counters__window-item__image --empty"
}
const _hoisted_6 = {
  key: 1,
  class: "roaming-counters__window-empty"
}

import type { PropType } from "@vue/runtime-core";
import { RoamingCountryStruct } from "@/struct/RoaminStruct";

import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoamingCountersListWindow',
  props: {
  countersList: {
    type: Object as PropType<RoamingCountryStruct[]>,
    required: true,
  },
  isSelectType: {
    type: Boolean,
    default: false,
  },
  uuidActive: {
    type: String,
    default: "",
  },
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const { t } = useI18n();

const selectCountry = (country: RoamingCountryStruct) => {
  if (props.isSelectType) {
    emits("select", country);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["roaming-counters__window", { '--type-select': __props.isSelectType }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.countersList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.countersList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (selectCountry(item)),
                class: _normalizeClass(["roaming-counters__window-item", { '--active': __props.uuidActive === item.uuid }])
              }, [
                (item.img_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "roaming-counters__window-item__image",
                      src: item.img_url,
                      alt: _unref(t)('roaming.list.flagAlt')
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5)),
                _createElementVNode("span", null, _toDisplayString(item.country_name_ru), 1)
              ], 10, _hoisted_3))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("roaming.list.empty")), 1)
          ]))
    ])
  ], 2))
}
}

})